export default __webpack_public_path__ + "static/media/c++.848ffa12.png";